<script lang="ts">
	import ScannerConfiguration, { type ScannerOptions } from '@isoftdata/svelte-scanner-configuration'
	import { setObject } from '@isoftdata/utility-storage'
	import { getContext } from 'svelte'
	import type { i18n } from 'types/common'
	const { t: translate } = getContext<i18n>('i18next')

	export let barcodeScannerOptions: ScannerOptions
</script>

<small
	>{translate(
		'configuration.scanner.noteThisConfigurationOnlyAffectsThisDevice.',
		'Note: This configuration only affects this device.',
	)}</small
>
<hr />
<ScannerConfiguration
	preamble={barcodeScannerOptions.preamble}
	postamble={barcodeScannerOptions.postamble}
	enableHoneywell={barcodeScannerOptions.enableHoneywell}
	on:change={e => {
		setObject(localStorage, 'barcodeScannerOptions', e.detail)
	}}
/>
